<template>
  <div class="object-fit-wrapper">
    <slot v-bind="contentStyle"></slot>
  </div>
</template>

<script>
const supportsObjectFit = window.CSS && window.CSS.supports &&
                          window.CSS.supports('object-fit', 'cover') &&
                          !/Edge/.test(window.navigator.userAgent)
// const isEdge = /Edge/.test(window.navigator.userAgent)

export default {
  props: {
    aspectRatio: {
      type: Number,
      default: 1
    }
  },
  watch: {
    aspectRatio () {
      this.onReisze()
    }
  },
  computed: {
    widthPrior () {
      return this.aspectRatio * this.$window.innerWidth >= this.$window.innerHeight
    },
    targetWidth () {
      return this.widthPrior ? `${this.$window.innerWidth}` : `${this.$window.innerHeight / this.aspectRatio}`
    },
    targetHeight () {
      return this.widthPrior ? `${this.$window.innerWidth * this.aspectRatio}` : `${this.$window.innerHeight}`
    },
    contentStyle () {
      let width = '100%'
      let height = '100%'
      let objectFit = 'cover'

      if (!supportsObjectFit) {
        width = this.widthPrior ? '100%' : 'auto'
        height = this.widthPrior ? 'auto' : `${this.$window.innerHeight}px`
        // objectFit = 'unset'
      }

      return {width, height, objectFit}
    }
  },
  mounted () {
    this.onReisze()
    window.addEventListener('resize', this.onReisze)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onReisze)
  },
  methods: {
    onReisze () {
      let width = '100%'
      let height = `100%`
      let objectFit = 'cover'
      const isCanvas = this.$el.children[0].tagName === 'CANVAS'
      const isImage = this.$el.children[0].tagName === 'IMG'

      if ((!supportsObjectFit || isCanvas) && !isImage) {
        width = isCanvas ? this.targetWidth : `${this.targetWidth}px`
        height = isCanvas ? this.targetHeight : `${this.targetHeight}px`
        // objectFit = 'unset'
      }

      Array.prototype.forEach.call(this.$el.children, el => {
        if (isCanvas) {
          // el.width = width
          // el.height = height
          el.width = width
          el.height = window.innerHeight
        } else {
          el.style.width = width
          el.style.height = height
          el.style.objectFit = objectFit
        }

      })
    }
  }
}
</script>

<style lang="scss">
.object-fit-wrapper {
  position: relative;
  width: 100%;
  height: 100;

  & > * {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
